import WebCamModal from "../classes/WebCamModal";

(() => {
    const initWebcams = () => {
        new WebCamModal(document.querySelector('.webcam-modal'));
    };

    initWebcams();
})();